import { render, staticRenderFns } from "./MobQuoteHeader.vue?vue&type=template&id=034d8480&scoped=true"
import script from "./MobQuoteHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MobQuoteHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobQuoteHeader.vue?vue&type=style&index=0&id=034d8480&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034d8480",
  null
  
)

export default component.exports